import { Suspense, lazy } from "react";

import { observer } from "@legendapp/state/react";
import retry from "../../../tools/retry";
import LoaderSearchPages from "./loader/LoaderSearch";

export interface ISearchPages {
    isLoading: boolean,
    isDisabled?: boolean,
    customClass?: string,
    value: string,
    setValue: (value: string) => void,
    requestSubmit: (value: string) => void,
    requestClear: () => void,
    isClearPresent?: boolean,
    error?: string
}

const FormSearchPages = lazy(() => retry(() => import('./form/FormSearch')));

const SearchPages = observer(({ isLoading, isDisabled, customClass, setValue, value, requestSubmit, requestClear, error, isClearPresent }: ISearchPages) => {
    return (
        <Suspense fallback={<LoaderSearchPages />}>
            {
                isLoading ?
                    <LoaderSearchPages customClass="page-loader--search--inline" /> :

                    <FormSearchPages
                        isDisabled={isDisabled}
                        requestClear={handleClear}
                        requestSubmit={handleSubmit}
                        customClass={customClass}
                        requestInput={setValue}
                        isClearPresent={isClearPresent}
                        error={error}
                        value={value} />
            }
        </Suspense>
    )

    function handleClear() {
        if (!setValue ||
            !requestClear) {
            return;
        }

        setValue('');

        return requestClear();
    }

    function handleSubmit(event: string) {
        if (!event ||
            !event.length ||
            !requestSubmit) {
            return;
        }

        return requestSubmit(event);
    }
})

export default SearchPages;
